import "react-toastify/dist/ReactToastify.css";
import AppRoutes from './routes';
import { AuthContext, AuthContextProvider } from "./Contexts/AuthContext";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useContext } from "react";
import { FaSpinner } from "react-icons/fa6";
import { AlertCircle } from "lucide-react";

function AppContent() {
    const { isAuthenticated, isLoading } = useContext(AuthContext);

    if (isLoading) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-sky-50 to-blue-50 flex items-center justify-center">
                <div className="bg-white p-6 rounded-2xl shadow-md flex items-center space-x-3 text-sky-600">
                    <FaSpinner className="animate-spin h-5 w-5" />
                    <span className="text-base font-medium">Carregando sessão...</span>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-sky-50 to-blue-50 flex items-center justify-center">
                <div className="bg-white p-6 rounded-2xl shadow-xl max-w-md w-full mx-4 text-center border border-red-200">
                    <AlertCircle className="w-10 h-10 mx-auto text-red-500 mb-3" />
                    <h2 className="text-lg font-bold text-gray-600 mb-2">Erro de Autenticação</h2>
                    <p className="text-sm text-gray-600 mb-4">
                        Não foi possível carregar a aplicação. Verifique se o link de pagamento está correto.
                    </p>
                    <button
                        onClick={() => window.location.reload()}
                        className="w-full bg-sky-500 text-white py-2.5 px-4 rounded-xl hover:bg-sky-600 transition-all font-medium text-sm mt-4"
                    >
                        Tentar Novamente
                    </button>
                </div>
            </div>
        );
    }
    
    return <AppRoutes />;
}


function App() {
  return (
    <AuthContextProvider>
        <DndProvider backend={HTML5Backend}>
            <AppContent />
        </DndProvider>
    </AuthContextProvider>
  );
}

export default App;